import { combineReducers } from '@reduxjs/toolkit';
export default class ReduxInjector {
    #sagas;
    #reducers;
    #store;
    #sagaMiddleware;
    constructor(store, sagaMiddleware, staticReducers, rootSaga) {
        this.#store = store;
        this.#reducers = { ...staticReducers };
        this.#sagaMiddleware = sagaMiddleware;
        this.#sagas = { rootSaga: this.#sagaMiddleware.run(rootSaga) };
    }

    #reduce = () => combineReducers(this.#reducers);
    inject = (key, reducer, saga) => {
        if (!key) {
            this.#log(`inject(): Key not provided`);
            return;
        }
        if (!reducer) {
            this.#log(`inject(): Reducer not provided`);
            return;
        }
        if (!this.#reducers[key]) {
            this.#reducers[key] = reducer;
            this.#store.replaceReducer(this.#reduce());
            this.injectSaga(key, saga);
            return;
        }
        this.#log(`inject(): Key=${key} already registered, please use different key. Registered keys=[${Object.keys(this.#reducers)}]`);
    };

    injectSaga(key, saga) {
        if (!key) {
            this.#log(`injectSaga(): Key not provided`);
            return;
        }
        if (!saga) {
            this.#log(`injectSaga(): Saga not provided`);
            return;
        }
        if (!Object.hasOwn(this.#sagas, key)) {
            this.#sagas[key] = this.#sagaMiddleware.run(saga);
            return;
        }
        this.#log(`injectSaga(): Key=${key}, already registered, please use different key. Registered keys=[[${Object.keys(this.#sagas)}] `);
    }

    #log(message, mode = 'error') {
        console[mode](`[ReduxInjector] ${message}`);
    }
}
